<template>

<li class="relative px-4 py-8 sm:px-6" :class="{ 'first:pt-0': enquiry.IsNew, 'bg-gray-50': !enquiry.IsNew }">
  <div v-if="!showDeleted" class="space-y-3">
    <div class="flex items-center space-x-3">

      <!-- Is New -->
      <span v-if="enquiry.IsNew" class="relative flex h-2.5 w-2.5">
        <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
        <span class="relative inline-flex rounded-full h-2.5 w-2.5 bg-red-500"></span>
      </span>

      <!-- Added When -->
      <time :datetime="enquiry.AddedWhen" class="text-xs text-gray-400 uppercase sm:text-sm">
        {{ dayjs(enquiry.AddedWhen).fromNow() }}
      </time>
      
    </div>

    <div>
      <!-- Name -->
      <h3 class="text-lg text-blue-600 font-medium">
        {{ enquiry.EnquirersName }}
      </h3>

      <!-- Subject/Level -->
      <div class="text-sm font-medium text-gray-500">
        <span class="hidden font-normal sm:inline">Would like tutoring for: </span>
        <span class="text-gray-600">{{ enquiry.EnquirersSubjectsAndLevels }}</span>
      </div>
    </div>

    <!-- Message -->
    <p class="py-2 text-gray-800 whitespace-pre-line">{{ enquiry.EnquirersMessage }}</p>

    <div class="space-y-4 md:space-y-0 md:flex md:justify-between md:items-center">
      <div class="space-y-1 sm:flex sm:space-y-0 sm:space-x-5">
        <div class="flex items-center space-x-1">
          <phone-icon class="w-5 h-5 text-gray-400"></phone-icon>
          <a :href="`tel:${enquiry.EnquirersPhone}`" class="text-sm text-blue-600">{{ enquiry.EnquirersPhone }}</a>
        </div>
        <div class="flex items-center space-x-1">
          <at-symbol-icon class="w-5 h-5 text-gray-400"></at-symbol-icon>
          <a :href="`mailto:${enquiry.EnquirersEmail}`" class="text-sm text-blue-600">{{ enquiry.EnquirersEmail }}</a>
        </div>
      </div>
      <div class="flex space-x-2">
        <button type="button" @click="showDeleteConfirmation = true" class="group inline-flex items-center space-x-1 px-2.5 py-1.5 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-600 hover:bg-red-600 hover:text-white hover:border-red-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500">
          <trash-icon class="w-5 h-5 text-gray-500 group-hover:text-white"></trash-icon>
          <span>Delete</span>
        </button>
        <!-- <button type="button" class="inline-flex items-center px-2.5 py-1.5 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
            Not Interested
        </button>
        <button type="button" class="inline-flex items-center px-2.5 py-1.5 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
            Mark As Spam
        </button> -->
      </div>
    </div>
  </div>

  <div v-if="showDeleteConfirmation" class="absolute inset-0 px-4 py-6 space-y-4 bg-red-50 flex flex-col justify-end items-center sm:px-6">
    <h3 class="space-x-1 text-center text-red-900 font-medium">
      <trash-icon class="inline w-5 h-5 align-top"></trash-icon>
      <span>Are you sure you want to delete{{'\xa0'}}this{{'\xa0'}}enquiry?</span>
    </h3>
    <p class="text-xs text-gray-600 text-center prose prose-sm">Before deleting, have you responded to {{ enquiry.EnquirersName }}? Even if you are unable to provide tutoring services on this occasion, it is a professional courtesy to inform them.</p>
    <div class="space-x-3">
      <tti-button @click="onConfirmDelete" color="red" :loading="isDeleting" :disabled="isDeleting">Delete</tti-button>
      <tti-button @click="showDeleteConfirmation = false" theme="outline">Cancel</tti-button>
    </div>
  </div>

  <div v-if="showDeleted" class="absolute z-10 inset-0 px-4 py-6 bg-red-50 text-red-900 flex justify-center items-center space-x-1 sm:px-6">
    <check-circle-icon class="w-5 h-5"></check-circle-icon>
    <span>Deleted</span>
  </div>

</li>
    
</template>
<script>
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import utc from 'dayjs/plugin/utc'
dayjs.extend(relativeTime)
dayjs.extend(utc)

import { PhoneIcon, AtSymbolIcon, TrashIcon, CheckCircleIcon } from '@vue-hero-icons/solid'

import EnquiryService from '@/services/EnquiryServices'
const enquiryService = new EnquiryService()

export default {
  components: {
    PhoneIcon,
    AtSymbolIcon,
    TrashIcon,
    CheckCircleIcon,
    'tti-button': () => import('./TailwindButton.vue')
  },
  props: ['enquiry'],
  data() {
    return {
      dayjs,
      showDeleteConfirmation: false,
      isDeleting: false,
      showDeleted: false
    }
  },
  methods: {
    async onConfirmDelete() {
      this.isDeleting = true

      await enquiryService.deleteEnquiry(this.enquiry.Id)
      
      this.isDeleting = false
      this.showDeleteConfirmation = false
      this.showDeleted = true

      setTimeout(() => {
        this.$emit('delete', this.enquiry.Id)
      }, 2000)
    }
  }
}
</script>